import { useEffect, useState } from "react";
import { Archive } from "lucide-react";
import { api } from "@/lib/api";
import Modal from "@/components/Modal";
import ArchiveCard from "@/components/ArchiveCard";

export default function ArchiveButton() {
  const [open, setOpen] = useState(false);
  const [n, setN] = useState(0);
  useEffect(() => { api.get("/archive/status").then((r) => setN(r.data.total)).catch(() => {}); }, [open]);
  return (
    <>
      <button data-testid="archive-open-btn" onClick={() => setOpen(true)} title="طباعة كل المدخلات"
        className="group relative flex items-center gap-2 h-12 ps-2 pe-4 rounded-2xl bg-white border border-brand/15 shadow-sm hover:shadow-md hover:border-brand/40 transition-[box-shadow,border-color]">
        <span className="w-9 h-9 rounded-xl bg-brand text-white flex items-center justify-center group-hover:scale-105 transition-transform"><Archive className="w-5 h-5" /></span>
        <b className="text-brand">أرشيف المدخلات</b>
        {n > 0 && <span data-testid="archive-badge" className="absolute -top-2 -start-2 min-w-6 h-6 px-1.5 rounded-full bg-red-600 text-white text-xs font-black flex items-center justify-center border-2 border-white">{n}</span>}
      </button>
      <Modal open={open} onClose={() => setOpen(false)} title="طباعة كل المدخلات PDF" testid="archive-modal" wide>
        <ArchiveCard bare />
      </Modal>
    </>
  );
}
